import { useQuery } from "@tanstack/react-query";
import { useRestAPI } from "./axiosAPI";
import { useAzureApis, WorkItemType } from "./azureAPIs";
import { useUsersAPI } from "./central.usersAPI";
import { useCentralAPI, WorkItemTypeCentral } from "./centralAPI";

const QUERY_KEY = 'users-task'

export function useUsersTaskAPI({
    retryCount = 1,
    trigger = true,
    ASOF
}: {
    retryCount?: number,
    trigger?: boolean,
    ASOF?: string
}) {

    const {
        listUsers
    } = useUsersAPI()
    const api = useRestAPI()
    const { getWorkItem,
        loadWorkItemsDetails
    } = useAzureApis()

    const {
        centralData } = useCentralAPI({ trigger: false })






    const {
        data: users,
        isLoading,
        isError,
        refetch: refetchUsers,
        isFetching,
        isFetched,
        error
    } = useQuery({
        queryKey: [QUERY_KEY, ASOF],
        queryFn: async () => {

            const users = await listUsers({
                filters: {

                }
            })



            let responseUsers = users?.map(
                item => {
                    return {
                        ...item,
                        projects: item.projects.map(project => ({ ...project, tasks: [] as WorkItemTypeCentral[], organisationName: '' as string }))

                    }
                }
            ) || []

            responseUsers = []

            // const workItems: (WorkItemType & { organization: string, project: string })[] = []

            // await Promise.all(
            //     centralData?.Organizations.map(async (organization) => {

            //         //get all issue that undone in this organization
            //         const issues = await getWorkItem({
            //             organization: organization?.accountName || '',
            //             // project: project.name,
            //             state: {
            //                 condition: '<>',
            //                 state: 'Done'
            //             },
            //             workItemType: {
            //                 condition: '=',
            //                 type: 'Issue'
            //             },
            //             // assignedTo:user.user.mailAddress,
            //             // ASOF
            //         })
            //         //load work items details
            //         const response2 = issues.length ? await loadWorkItemsDetails({
            //             // projectId: project.id,
            //             organisationName: organization?.accountName || '',
            //             workItemIds: issues.map(issue => issue.id),
            //             projectType: 'basic'
            //         }) : []

            //         let response = response2.map(issue => ({ ...issue, organization: organization?.accountName || '', project: issue.fields?.["System.TeamProject"] || '' }))

            //         workItems.push(...response)

            //     }) || []
            // )

            // console.log(workItems)

            const workItems = centralData?.workItemsWithOrganizationId.filter(
                        workItem=>{
                            return  workItem.revisions[workItem.revisions.length-1].fields["System.State"]!=='Done'
                        }
                    )||[]

            users.forEach(user => {


                const projects = user.projects
                const projectResponse = projects.map(project => ({ ...project, tasks: [] as WorkItemTypeCentral[], organisationName: '' as string }))

                projectResponse.forEach(project => {

                    //get all issue that undone in this project
                    const organization = centralData?.Organizations.find((organization) => organization.accountId === project.organization_accountId)
                    const issues = workItems.filter((issue) => issue.revisions[issue.revisions.length - 1].fields["System.TeamProject"] === project.name && issue.organizationId === organization?.accountId && issue.revisions[issue.revisions.length - 1].fields?.["System.AssignedTo"]?.uniqueName === user.user.mailAddress)
                    project.tasks = issues
                    project.organisationName = organization?.accountName || ''
                })

                responseUsers.push({
                    ...user,
                    projects: projectResponse
                })

            })



            // await Promise.all(users.map(async (user) => {



            //     const projects = user.projects
            //     const projectResponse = projects.map(project => ({...project, tasks:[] as WorkItemType[]}))
            //     await Promise.all(projectResponse.map(async (project) => {

            //         //get all issue that undone in this project
            //         const organization = centralData?.Organizations.find((organization) => organization.accountId === project.organization_accountId)
            //         const issues = await getWorkItem({
            //             organization: organization?.accountName||'',
            //             project: project.name,
            //             state: {
            //                 condition: '<>',
            //                 state: 'Done'
            //             },
            //             workItemType: {
            //                 condition: '=',
            //                 type: 'Issue'
            //             },
            //             assignedTo:user.user.mailAddress,
            //             ASOF
            //         })

            //         //load work items details
            //         const response2 = issues.length ? await loadWorkItemsDetails({
            //             projectId: project.id,
            //             organisationName: organization?.accountName||'',
            //             workItemIds: issues.map(issue => issue.id),
            //             projectType: 'basic'
            //         }):[]

            //         project.tasks = response2




            //     }))

            //     responseUsers.push({
            //         ...user,
            //         projects: projectResponse
            //     })
            // }))



            return responseUsers


        },
        refetchOnWindowFocus: false,
        retry: retryCount,
        enabled: trigger

    })

    return {
        users,
        isLoading,
        isError,
        refetchUsers,
        isFetching,
        isFetched,
        error
    }


}

export function useUserTaskAPI({
    retryCount = 1,
    trigger = true,
    id,
    ASOF
}: {
    retryCount?: number,
    trigger?: boolean,
    ASOF?: string,
    id: string | null
}) {

    const {
        getUserById
    } = useUsersAPI()
    const api = useRestAPI()
    const { getWorkItem,
        loadWorkItemsDetails
    } = useAzureApis()

    const {
        centralData
    } = useCentralAPI({ trigger: false })






    const {
        data: user,
        isLoading,
        isError,
        refetch: refetchUsers,
        isFetching,
        isFetched,
        error
    } = useQuery({
        queryKey: [QUERY_KEY, ASOF, id],
        queryFn: async () => {

            const user =  getUserById({
                id: id!
            })

            if (!user) {
                return null
            }

            let responseUsers = [{
                ...user,
                projects: user.projects.map(project => ({ ...project, tasks: [] as WorkItemTypeCentral[], organisationName: '' as string }))

            }
            ]

            responseUsers = []

            // const workItems: (WorkItemType & { organization: string, project: string })[] = []

            // await Promise.all(
            //     centralData?.Organizations.map(async (organization) => {

            //         //get all issue that undone in this organization
            //         const issues = await getWorkItem({
            //             organization: organization?.accountName || '',
            //             // project: project.name,
            //             state: {
            //                 condition: '<>',
            //                 state: 'Done'
            //             },
            //             workItemType: {
            //                 condition: '=',
            //                 type: 'Issue'
            //             },
            //             // assignedTo:user.user.mailAddress,
            //             // ASOF
            //         })
            //         // load work items details
            //         const response2 = issues.length ? await loadWorkItemsDetails({
            //             // projectId: project.id,
            //             organisationName: organization?.accountName || '',
            //             workItemIds: issues.map(issue => issue.id),
            //             projectType: 'basic'
            //         }) : []

                    



            //         let response = response2.map(issue => ({ ...issue, organization: organization?.accountName || '', project: issue.fields?.["System.TeamProject"] || '' }))

            //         workItems.push(...response)

            //     }) || []
            // )


            const workItems = centralData?.workItemsWithOrganizationId.filter(
                        workItem=>{
                            return workItem.revisions[workItem.revisions.length - 1].fields["System.AssignedTo"]?.uniqueName === user.user.mailAddress && workItem.revisions[workItem.revisions.length-1].fields["System.State"]!=='Done'
                        }
                    )||[]




            const projects = user.projects
            const projectResponse = projects.map(project => ({ ...project, tasks: [] as WorkItemTypeCentral[], organisationName: '' as string}))
            projectResponse.forEach(project => {

                //get all issue that undone in this project
                const organization = centralData?.Organizations.find((organization) => organization.accountId === project.organization_accountId)
                const issues = workItems.filter((issue) => issue.revisions[issue.revisions.length - 1].fields?.["System.TeamProject"] === project.name && issue.organizationId === organization?.accountId && issue.revisions[issue.revisions.length - 1].fields?.["System.AssignedTo"]?.uniqueName === user.user.mailAddress)
                project.tasks = issues
                project.organisationName = organization?.accountName || ''
            })

            responseUsers.push({
                ...user,
                projects: projectResponse
            })




            return responseUsers[0]


        },
        refetchOnWindowFocus: false,
        retry: retryCount,
        enabled: trigger && id !== null

    })

    return {
        user,
        isLoading,
        isError,
        refetchUsers,
        isFetching,
        isFetched,
        error
    }


}

